<script setup>

import {computed, inject, onMounted,ref} from "vue";
import API from "@/classes/global/API";
import Quote from "@/classes/viewmodels/Quote";
import QuoteEntry from "@/components/quote/QuoteEntry.vue";

import {useStore} from "vuex";
import {useRoute} from "vue-router";
import QuoteValidation from "@/classes/quote/QuoteValidation";

const quoteEdit = ref(new Quote());
const dataReady = ref(false);

const route = useRoute();
const store = useStore();
const quote = inject("quote");
const validationViewModel = inject("validationViewModel");

const quoteModel = computed({

  get() {

    if (route.params.id === 'new') {

      dataReady.value = !dataReady.value;

      return quote.value

    }

    return quoteEdit.value
  }

})

onMounted(() => {

  prepareMetaData();

})

async function prepareMetaData() {

  quote.value.validatedFields = await API.getQuoteValidators();

  const response = await API.getShipperMetaData(route, 'quote');

  if (response) {

    store.state.metaData.countries = response.countries;
    store.state.metaData.packagingTypes = response.packagingTypes;
    store.state.metaData.currencies = response.currencies;
    store.state.metaData.terms = response.terms;

    if (route.params.id !== 'new') {

      validationViewModel.value.quote = new QuoteValidation();
      getQuoteDetailForEdit(route.params.id)

    }

  }

}

async function getQuoteDetailForEdit(quoteRef) {

  let response = await API.getQuoteDetail(quoteRef);

  if (response) mapQuoteToEdit(response, quoteRef);

  let getChargesResult = await API.getQuoteCharges(quoteRef.split('Q')[1]);

  if(getChargesResult) {

    quoteEdit.value.chargeDescriptionsData = getChargesResult;

    quoteEdit.value.chargeDescriptionsData.forEach((item) => {

      quoteEdit.value.chargesTotal += item.charge;

      item.charge = item.charge.toFixed(2);

    })

    quoteEdit.value.chargesTotal =  quoteEdit.value.chargesTotal.toFixed(2);
  }

}

function mapQuoteToEdit(quoteDetail, quoteRef) {

  quoteDetail.quoteDims.multiLineDims.forEach((item) => {

    quoteEdit.value.model.dimensions.multiLineDims.push(item);
  })

  quoteEdit.value.model.valueCurrency = quoteDetail.valueCurrency;

  quoteEdit.value.portSelections.currencySelect =
      store.state.metaData.currencies.find(x => x.id === quoteDetail.valueCurrency);

  quoteEdit.value.portSelections.originSelection = quoteDetail.from;
  quoteEdit.value.portSelections.originCountry = quoteDetail.originCountry;
  quoteEdit.value.portSelections.destinationSelection = quoteDetail.to;
  quoteEdit.value.portSelections.destinationCountry = quoteDetail.destinationCountry;
  quoteEdit.value.portSelections.originPort = quoteDetail.fromAirport;
  quoteEdit.value.portSelections.destinationPort = quoteDetail.toAirport;

  quoteEdit.value.jobAccepted = quoteDetail.jobAccepted === -1;

  quoteEdit.value.model.quoteRef = quoteRef;
  quoteEdit.value.model.quoteType = quoteDetail.quoteType;
  quoteEdit.value.model.transportMode = quoteDetail.transportMode;
  quoteEdit.value.model.origin = quoteDetail.from;
  quoteEdit.value.model.originPort = quoteDetail.fromAirportCode;
  quoteEdit.value.model.destination = quoteDetail.to;
  quoteEdit.value.model.destinationPort = quoteDetail.toAirportCode;
  quoteEdit.value.model.movementDate = quoteDetail.collectBy || '';
  quoteEdit.value.model.deliveryDate = quoteDetail.deliverBy || '';
  quoteEdit.value.model.customerRef = quoteDetail.customerReference;
  quoteEdit.value.model.commodity = quoteDetail.commodity;
  quoteEdit.value.model.value = quoteDetail.value;
  quoteEdit.value.model.hazardClass = quoteDetail.hazardousClass;
  quoteEdit.value.model.insurance = quoteDetail.insurance;
  quoteDetail.freightTerms ? quoteEdit.value.quoteTerms[quoteDetail.freightTerms.toLowerCase()] = true : false;
  quoteEdit.value.model.freightTerms = quoteDetail.freightTerms;
  quoteEdit.value.model.dimensions.totalPieces = quoteDetail.quoteDims.totalPieces;
  quoteEdit.value.model.dimensions.totalWeight = quoteDetail.quoteDims.totalWeight;
  quoteEdit.value.model.additionalInformation = quoteDetail.additionalInformation;
  quoteEdit.value.model.dimensions.cube = quoteDetail.quoteDims.cube;
  quoteEdit.value.model.dimensions.totalWeight = quoteDetail.quoteDims.totalWeight;
  quoteEdit.value.model.dimensions.chargeableWeight = quoteDetail.quoteDims.chargeableWeight;

  dataReady.value = true;

}
</script>

<template>
  <QuoteEntry
      :key="dataReady"
      v-model="quoteModel">
  </QuoteEntry>
</template>

<style scoped>

</style>
